import { useTranslation } from "react-i18next";
import { useGetInvoiceV1 } from "@/api/invoice";
import { useGetCompany } from "@/api/company.api";
import { useState } from "react";
import { StyledTableBisManualPag } from "@/components/styled/StyledTableBisManualPag";
import usePagination from "@/hooks/useSyncedPagination";
import { useDisplayDocument } from "@/hooks/useDisplayDocument";
import { useInvoiceTableColumns } from "./invoiceTableColumns";
import { useGetBillingEntities } from "@/api/billingEntity.api";
import { SelectV2 } from "@/components/ui/customs/select-v2";

export const InvoiceTable = () => {
  const { t } = useTranslation("boClients");
  const [selectedBillingEntity, setSelectedBillingEntity] = useState<string | null>(null);
  const [pagination, setPagination] = usePagination("invoice");

  const { data: invoices } = useGetInvoiceV1({
    billingEntityId: selectedBillingEntity || undefined,
    take: pagination.pageSize,
    skip: pagination.pageIndex * pagination.pageSize,
  });
  const { data: company } = useGetCompany();

  const { data: billingEntities } = useGetBillingEntities({
    includeDeleted: true,
  });

  const { displayDocument } = useDisplayDocument();
  const columns = useInvoiceTableColumns(displayDocument, company);

  return (
    <>
      <SelectV2
        placeholder={t("invoicesInvoiceTable.billingEntityPlaceholder")}
        searchable={false}
        options={
          billingEntities?.data.map((billingEntity) => ({
            value: billingEntity.id,
            label: billingEntity.deletedAt
              ? t("invoicesInvoiceTable.deletedBillingEntity", {
                  companyName: billingEntity.companyName,
                })
              : billingEntity.companyName,
          })) || []
        }
        onChange={(value) => setSelectedBillingEntity(value || "")}
        value={selectedBillingEntity || undefined}
        wrapperClassName="w-[300px]"
        clearable
      />
      <StyledTableBisManualPag
        data={invoices?.data || []}
        columns={columns}
        pagination={pagination}
        rowCount={invoices?.count || 0}
        setPagination={setPagination}
      />
    </>
  );
};
